import {
	FiGithub,
	FiTwitter,
	FiLinkedin,
	FiGlobe,
	FiYoutube,
} from 'react-icons/fi';
import AppFooterCopyright from './AppFooterCopyright';

const socialLinks = [
	{
		id: 1,
		icon: <FiGlobe />,
		url: 'https://www.ethanwei.me/',
	},
	{
		id: 2,
		icon: <FiGithub />,
		url: 'https://github.com/belligerentbeagle',
	},
	{
		id: 3,
		icon: <FiTwitter />,
		url: 'https://twitter.com/weiyushit',
	},
	{
		id: 4,
		icon: <FiLinkedin />,
		url: 'https://www.linkedin.com/in/ethan-weiyx/',
	},
	{
		id: 5,
		icon: <FiYoutube />,
		url: 'https://www.youtube.com/@belligerentbeagle',
	},
];

const AppFooter = () => {
	return (
		<footer className="border-t border-black/[0.08] dark:border-white/[0.08] bg-slate-100/60 dark:bg-[#121214] mt-24">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
				{/* Footer social links */}
				<div className="flex flex-col justify-center items-center mb-8">
					<p className="text-sm font-semibold tracking-wider uppercase text-slate-500 dark:text-slate-400 mb-6">
						Connect with Ethan
					</p>
					<ul className="flex items-center gap-3 sm:gap-4">
						{socialLinks.map((link) => (
							<li key={link.id}>
								<a
									href={link.url}
									target="_blank"
									rel="noopener noreferrer"
									className="w-10 h-10 rounded-full flex items-center justify-center bg-black/5 dark:bg-white/10 hover:bg-black/10 dark:hover:bg-white/20 active:scale-95 text-slate-600 dark:text-slate-300 transition-all duration-200"
									aria-label={`Link to ${link.url}`}
								>
									<span className="text-lg">
										{link.icon}
									</span>
								</a>
							</li>
						))}
					</ul>
				</div>

				<AppFooterCopyright />
			</div>
		</footer>
	);
};

export default AppFooter;
